import { TableColumn } from '@shared/interfaces';
import { Contents } from '../interface';

/**
 * The columns for the contents table.
 */
export const CONTENTS_COLUMNS: TableColumn[] = [
    { field: 'name', header: 'Name', width: '250px' },
    { field: 'type', header: 'Type', width: '150px' },
    { field: 'totalPlayCount', header: 'Total Play Count', width: '180px' },
    { field: 'totalDuration', header: 'Total Duration', width: '180px' },
    { field: 'uploadDate', header: 'Upload Date', width: '180px' },
    { field: 'uploadBy', header: 'Upload By', width: '180px' },
    {
        field: 'actions',
        header: 'Action',
        width: '120px',
        type: 'actions',
        actions: [{ icon: 'play', name: 'play', color: '#8DCB2C' }],
    },
];

/**
 * Dummy content data matching the table columns.
 * Will be replaced with API data.
 */
export const CONTENTS_DATA: Contents[] = [
    {
        id: '1',
        name: 'lorem.jpeg',
        type: 'Image',
        totalPlayCount: 0,
        totalDuration: 0,
        uploadDate: 'March 3, 2025',
        uploadBy: 'Lorem Ipsum',
    },
    {
        id: '2',
        name: 'video_sample.mp4',
        type: 'Video',
        totalPlayCount: 120,
        totalDuration: 30,
        uploadDate: 'February 15, 2025',
        uploadBy: 'Jane Doe',
    },
    {
        id: '3',
        name: 'background_music.mp3',
        type: 'Audio',
        totalPlayCount: 50,
        totalDuration: 180,
        uploadDate: 'January 10, 2025',
        uploadBy: 'John Smith',
    },
];
